import React, { useEffect, useState } from "react";
import "./Loader.css";

function Loader() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let frame;
    let startTime = null;
    const duration = 3000; // Duration in milliseconds (3 seconds for full load)

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const newProgress = Math.min((elapsed / duration) * 100, 100);
      setProgress(newProgress);

      if (newProgress < 100) {
        frame = requestAnimationFrame(animate);
      }
    };

    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, []);

  // Enhanced color transition
  const getFillColor = () => {
    const intensity = Math.min(progress / 100, 1);
    // Gradient from white/gray to vibrant red
    const r = 255;
    const g = Math.floor(255 - intensity * 200);
    const b = Math.floor(255 - intensity * 200);
    return `rgb(${r}, ${g}, ${b})`;
  };

  return (
    <div className="loader-container">
      <svg viewBox="0 0 600 120" className="loader-svg">
        <defs>
          <clipPath id="fill-clip">
            <rect
              x="0"
              y={120 - progress * 1.2}
              width="600"
              height={progress * 1.2}
            />
          </clipPath>
        </defs>
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          className="loader-fill"
          style={{
            clipPath: "url(#fill-clip)",
            fill: getFillColor(),
          }}
        >
          MadeByAngel
        </text>
      </svg>

      <div className="progress-indicator">
        <div className="progress-bar-container">
          <div className="progress-bar" style={{ width: `${progress}%` }}></div>
        </div>
        <div className="progress-percentage">{Math.floor(progress)}%</div>
      </div>

      <div className="loading-dots">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </div>
  );
}

export default Loader;
